<template>
  <div class="twt__table-wrapper">
    <div ref="tableRef" class="twt__table-inner">
      <table>
        <thead>
          <tr v-for="row in currentTable.slice(0, 1)" :key="row.join(',')">
            <th
              v-for="cell in row"
              :key="cell"
              class="twt__table-cell twt__colHeader"
            >
              {{ cell }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row in currentTable.slice(1)"
            :key="row.join(',')"
            class="twt__table-row"
          >
            <component
              :is="j === 0 ? 'th' : 'td'"
              v-for="(cell, j) in row"
              :key="cell"
              :class="['twt__table-cell', { 'twt__rowHeader ': j === 0 }]"
            >
              {{ cell }}
            </component>
          </tr>
        </tbody>
      </table>
    </div>
    <button
      class="twt__scroll-btn"
      v-if="isTableScrollable"
      @click="scrollTableToEnd"
    >
      Scroll to view all sizes
      <svg class="twt__table-icon">
        <use xlink:href="#icon-arrow-right"></use>
      </svg>
    </button>
  </div>
</template>

<script setup>
import { onMounted, toRefs, ref } from "vue";

const props = defineProps({
  data: {
    type: String,
    required: true,
  },
});

const { data: tableData } = toRefs(props);
const tableRef = ref(null);
const isTableScrollable = ref(false);

onMounted(() => {
  updateIsTableScrollable();
  window.addEventListener("resize", updateIsTableScrollable);
});

const updateIsTableScrollable = () => {
  isTableScrollable.value = tableRef.value.scrollWidth > tableRef.value.clientWidth;
};

const formatTable = (str) => {
  return str.value.split("\n").map((row) =>
    row
    .split("|")
    .map((str) => str.trim())
    .map((str) => (str === "null" ? "" : str))
    .map((str) => str.replace(/\"/, "”"))
  );
};

const currentTable = formatTable(tableData).slice(1, -1);

const scrollTableToEnd = () => {
  const wrapperRef = tableRef.value;
  if (wrapperRef) {  
    wrapperRef.scrollLeft = wrapperRef.scrollWidth - wrapperRef.clientWidth;
  }
};
</script>
